// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".field_key{font-style:normal;display:inline;color:#4575B4;font-weight:bold}.borderExperiment{border:1px solid #dee2e6 !important;padding:3%;border-radius:8px}\n", ""]);
// Exports
module.exports = exports;
